import React from 'react';
import Popup from '@techsoftware/happay-widgets/Popup';
import Checkbox from '@techsoftware/happay-widgets/Checkbox';

export default function Declaration({
  value,
  onClick,
  id,
  error,
  checkBoxWrapperStyle = {},
  disabled = false,
}) {
  return (
    <div className="declaration">
      <Popup
        id={`error-${id}`}
        open={error}
        pointerPlacement="top-left"
        popupStyle={{ top: 40, left: 0, zIndex: 'unset' }}
        // parentWrapperStyle={{ zIndex: 'unset !important'}}
        variant="scroll"
        borderStyle="1px solid #eb4646"
        border
        parentElement={
          <Checkbox
            id={id}
            value={value}
            label="I hereby declare that the subject registered vendor is not a related party/subsidiary/associate company/sister company of the Organization."
            onClick={(e, val) => onClick('declaration', val)}
            labelplacement="right"
            size="small"
            boxStyle={error ? { borderColor: '#eb4646' } : {}}
            checkBoxWrapperStyle={checkBoxWrapperStyle}
            disabled={disabled}
          />
        }
      >
        <div className="padding-10 body font-12">
          Please accept the declaration <br /> to proceed further.
        </div>
      </Popup>
    </div>
  );
}
